import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Provider as ProviderType, ProviderListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const PROVIDER_FIELDS = `createdDate deactivated displayName hasProfilePicture id isPrimary kollaConsumerId orgId pmsDisplayName pmsShortDisplayName practiceIds priority resourceName taxonomy updatedDate vendor vendorId version workspaceId`

const LIST_QUERY = graphql(`
  query Providers($search: String, $pagination: PaginationInput, $sort: SortInput) {
    providers(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        createdDate
        deactivated
        displayName
        hasProfilePicture
        id
        isPrimary
        kollaConsumerId
        orgId
        pmsDisplayName
        pmsShortDisplayName
        practiceIds
        priority
        resourceName
        taxonomy
        updatedDate
        vendor
        vendorId
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query Provider($id: ID!) {
    provider(id: $id) {
      createdDate
      deactivated
      displayName
      hasProfilePicture
      id
      isPrimary
      kollaConsumerId
      orgId
      pmsDisplayName
      pmsShortDisplayName
      practiceIds
      priority
      resourceName
      taxonomy
      updatedDate
      vendor
      vendorId
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateProvider($id: ID!, $input: UpdateProviderInput!) {
    updateProvider(id: $id, input: $input) {
      createdDate
      deactivated
      displayName
      hasProfilePicture
      id
      isPrimary
      kollaConsumerId
      orgId
      pmsDisplayName
      pmsShortDisplayName
      practiceIds
      priority
      resourceName
      taxonomy
      updatedDate
      vendor
      vendorId
      version
      workspaceId
    }
  }
`)

export class ProviderStore extends EntityStore<ProviderType, ProviderListResult, undefined, typeof UPDATE_MUTATION> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      updateMutation: UPDATE_MUTATION,
      extractList: (data: any) => data.providers,
      extractOne: (data: any) => data.provider,
      extractMutated: (data: any) => data.updateProvider,
    })
  }
}
